import { Box } from '@mui/material';
import React from 'react';


export const Error: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
      }}
    >
      <Box>We have problem</Box>
      <Box>Will be redirect to login</Box>
    </Box>
  );
};